import './ModuleCompletionAnimation.css';
import { BookCompletionIllustration, ConstellationCompletionIllustration, LeafCompletionIllustration } from './ModuleCompletionVariants';

export const MODULE_COMPLETION_VARIANTS = [
  'stepping-stones', 'leaf', 'book', 'constellation',
] as const;

export type ModuleCompletionVariant = typeof MODULE_COMPLETION_VARIANTS[number];

const TRAIL = 'M28 126 C65 126 67 91 112 91 S170 57 212 57 S262 31 292 31';

const SteppingStoneIllustration = () => (
    <svg viewBox="0 0 320 156" focusable="false" role="presentation">
      <path className="module-completion-animation__trail" d={TRAIL} pathLength="100" />
      <path className="module-completion-animation__light" d={TRAIL} pathLength="100" />
      <ellipse className="module-completion-animation__halo" cx="212" cy="57" rx="43" ry="31" />
      <g className="module-completion-animation__stone module-completion-animation__stone--first">
        <ellipse cx="57" cy="124" rx="30" ry="6" fill="#e6ded2" />
        <path d="M29 115 C29 104 41 98 57 99 C74 98 85 106 84 116 C83 126 68 130 54 128 C39 128 29 124 29 115Z" fill="#9ba98d" />
        <path d="M30 118 C43 125 70 127 84 116 C83 126 68 130 54 128 C39 128 30 124 30 118Z" fill="#879677" />
      </g>
      <g className="module-completion-animation__stone module-completion-animation__stone--second">
        <ellipse cx="129" cy="93" rx="31" ry="6" fill="#e6ded2" />
        <path d="M99 83 C100 72 113 67 130 68 C148 68 160 75 159 85 C158 95 143 100 126 99 C110 99 98 93 99 83Z" fill="#a9afc5" />
        <path d="M100 87 C112 95 143 96 159 85 C158 95 143 100 126 99 C110 99 100 93 100 87Z" fill="#949bb5" />
      </g>
      <g className="module-completion-animation__stone module-completion-animation__stone--current">
        <ellipse cx="212" cy="73" rx="35" ry="7" fill="#e6ded2" />
        <path className="module-completion-animation__completed-stone" d="M179 57 C179 44 194 35 213 36 C234 36 247 45 246 59 C245 72 229 79 209 77 C190 77 178 70 179 57Z" />
        <path d="M180 63 C195 74 229 76 246 59 C245 72 229 79 209 77 C190 77 180 70 180 63Z" fill="#a44c13" opacity=".22" />
        <path className="module-completion-animation__check" d="m201 56 8 8 15-16" pathLength="1" />
      </g>
      <path d="M263 103 Q259 96 260 91 M263 103 Q266 94 271 92 M85 52 Q82 46 83 42 M85 52 Q90 46 93 47" fill="none" stroke="#9ba98d" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const ILLUSTRATIONS = {
  'stepping-stones': SteppingStoneIllustration,
  leaf: LeafCompletionIllustration,
  book: BookCompletionIllustration,
  constellation: ConstellationCompletionIllustration,
};

export const ModuleCompletionAnimation = ({
  variant,
}: {
  variant: ModuleCompletionVariant;
}) => {
  const Illustration = ILLUSTRATIONS[variant];
  return (
    <div
      className="module-completion-animation"
      data-testid="flow-completion-animation"
      data-variant={variant}
      aria-hidden="true"
    >
      <Illustration />
    </div>
  );
};
